import { request } from '@kibt/krn-utils';
import { api } from '@/common/api';

export async function getKconfData(kconfKey: string) {
    try {
        const res = await request.post(api('/rest/o/w/kconf/loggedOut'), { paths: [kconfKey] }, { toastError: false });
        const jsonStr = res?.data?.[kconfKey];
        return JSON.parse(jsonStr || '{}');
    } catch (error) {
        console.log('get Kconf error', error);
        return Promise.reject(error);
    }
}

export interface IKconfRes {
    [kconfKey: string]: any;
}

/**
 * 一次获取多个kconf
 * @param kconfKeys kconf key数组
 * @returns 对象， key为kconf key，value为kconf json对象
 */
export async function getKconfDataV2(kconfKeys: string[]): Promise<IKconfRes> {
    try {
        const res = await request.post(api('/rest/o/w/kconf/loggedOut'), { paths: kconfKeys }, { toastError: false });
        const resObj = {} as any;
        for (const [kconfKey, kconfValue] of Object.entries(res?.data || {})) {
            try {
                const jsonObj = JSON.parse(kconfValue as string);
                resObj[kconfKey] = jsonObj;
            } catch (err) {
                console.log('get Kconf error', kconfKey, kconfValue, err);
            }
        }
        return resObj;
    } catch (error) {
        console.log('get Kconf error', error);
        return Promise.reject(error);
    }
}
